export enum SensorCheck {
  DELTA   = 'Delta',
  EXTREME = 'Extreme',
  MIN     = 'min',
  MAX     = 'max',
}
